(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name fuel.factory:FuelRequestFactory
     *
     * @description
     *
     */
    angular
        .module('hardSoftRule')
        .factory('HardSoftRuleRequestFactory', HardSoftRuleRequestFactory);

    function HardSoftRuleRequestFactory() {

        function SearchCriteriaDTO(){
            this.crewType = null;
            this.description = null;
            this.status = null;
            this.isHard = null;
        }

        function RuleDTO(){
        	this.regulationId = null;
        	this.companyValue1 = null;
        	this.durationForRoster = null;
        	this.desirability = null;
        	this.status = null;
        	this.version = null;
        	this.description = null;
        	this.acmiCodes = "";
        	this.ruleClassification = null;
        	this.onlyACMI = null;
        }


        function GetSearchRequest(params,isHard) {
            var search =  new SearchCriteriaDTO();
            search.crewType = params.crewType===null?null: params.crewType.crewTypeCode;
            search.description = params.description===null?null:params.description.regulationName;
            search.status = params.status===null?null:params.status.value;
            search.isHard = isHard;
            return search;
        }

        function GetRegForSave(reg) {
            var newReg = new RuleDTO();
            newReg.regulationId = reg.regulationId;
            newReg.durationForRoster = reg.durationForRoster;
            newReg.companyValue1 = reg.companyValue1;
            newReg.status = reg.status?"INA":"ACT";
            newReg.version = reg.version;
            newReg.desirability = reg.desirability/10;
            for (var i=0; i< reg.acmiCodes.length;i++){
            	newReg.acmiCodes +=  typeof reg.acmiCodes[i].acmiCode === 'undefined' ? "" :  reg.acmiCodes[i].acmiCode + ",";
            }
            newReg.ruleClassification = reg.ruleClassification.ruleClassificationCode;
            newReg.description = reg.description;
            newReg.onlyACMI = reg.onlyACMI ? "Y" : "N";
            return newReg;
        }

        function GetRegSearchRequest(){
        	return new SearchCriteriaDTO();
        }

        function GetRuleForEdit(){
                return new RuleDTO();
            }

        return {
        	getSearchRequest: GetSearchRequest,
        	getRegSearchRequest : GetRegSearchRequest,
        	getRuleForEdit:GetRuleForEdit,
        	getRegForSave :GetRegForSave
        }
    }
})();
